export default "__VITE_ASSET__RAOCg1W1__"